import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface LeadReenrichAddressRequest {
  leadId: string;
  // Operator-corrected address. The BE persists it on the lead and
  // re-runs the full enrichment pipeline (geocode -> buildings -> HMLR
  // -> Companies House) from it, refreshing the candidate data + the
  // auto-picked building. Works for any lead source, unlike /refetch
  // (VOA-only).
  address: string;
}

export interface LeadReenrichAddressResponse {
  lead: Lead;
}

const postLeadReenrichAddress = async (
  authToken: string,
  { leadId, address }: LeadReenrichAddressRequest
): Promise<LeadReenrichAddressResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${encodeURIComponent(leadId)}/reenrich-address`,
    { address },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadReenrichAddress;
